module.exports = __webpack_public_path__ + "img/rg-back.3809221f.png";